import { Metrics } from './metrics';
import { rhumbAggregator, type Bucket } from './rhumbAggregator';

let depth = 0;

function timed<T>(bucket: Bucket, fn: () => T, operationTimer?: string): T {
  depth++;
  const startTime = performance.now();
  try {
    return fn();
  } finally {
    const duration = performance.now() - startTime;
    depth--;
    if (operationTimer) {
      Metrics.timer(operationTimer).update(duration);
    }
    if (depth === 0) {
      Metrics.timer('cpuTime').update(duration);
    }
    rhumbAggregator.accumulate(bucket, duration);
  }
}

export const timing = {
  timeAttach<T>(fn: () => T): T {
    return timed('attach', fn);
  },
  timeDetach<T>(fn: () => T): T {
    return timed('detach', fn);
  },
  timeStateChange<T>(fn: () => T): T {
    return timed('stateChange', fn, 'lifecycleManager.handleStateChange');
  },
  timeInvalidate<T>(fn: () => T): T {
    return timed('invalidate', fn, 'lifecycleManager.invalidate');
  },
  timeInvalidateAll<T>(fn: () => T): T {
    return timed('invalidate', fn, 'lifecycleManager.invalidateAll');
  },
  timeCollectNode<T>(fn: () => T): T {
    return timed('gc', fn);
  },
  timeResync<T>(fn: () => T): T {
    return timed('resync', fn, 'lifecycleManager.resync');
  },
  timeMaterialize<T>(fn: () => T): T {
    return timed('materialize', fn, 'lifecycleManager.materialize');
  },
};
